// Module
var code = `{%- liquid
  assign label_text = label_text | default: nil
  assign show_percentage_saved = show_percentage_saved | default: true
  assign sale_price = sale_price | default: product.price | plus: 0
  assign tag_prefix = tag_prefix | default: nil
  assign icon_url = icon_url | default: nil

  if tag_prefix
    assign sale_tag = tag_prefix | append: "sale"
    assign bestseller_tag = tag_prefix | append: "bestseller"
  endif

  if label_text == nil
    assign tags_as_string = product.tags | join | downcase
    assign lower_title = product.title | downcase
    assign regular_price = product.compare_at_price | default: product.price
    if regular_price > sale_price
      assign on_sale = true
      if show_percentage_saved
        capture percentage_saved
          render 'percentage-saved', regular_price: regular_price, sale_price: sale_price
        endcapture
      endif
    endif
    if tags_as_string contains 'final sale' or lower_title contains 'final sale'
      assign label_text = "Final Sale"
    elsif tags_as_string contains "coming soon"
      assign label_text = "Coming Soon"
    elsif on_sale or tag_prefix and tags_as_string contains sale_tag
      assign label_text = "Sale"
    elsif tag_prefix and tags_as_string contains bestseller_tag
      assign label_text = "Bestseller"
    elsif tags_as_string contains 'badge:new'
      assign label_text = "New"
    endif
  endif
  assign label_text_handle = label_text | handleize
  assign label_style_class = label_style_class | default: label_text_handle
-%}

{%- if label_text %}
  <div class="product-badge-v2__container product-badge-v2__container--{{ label_style_class }} {% if icon_url %}product-badge-v2__container--has-icon{% endif %}" style="{% if font_color %}color: {{ font_color }};{% endif %} {% if background_color %}background-color: {{ background_color }};{% endif %}">
    <span class="product-badge-v2__text {% if on_sale and settings.product_pricing_show_percentage_saved and percentage_saved %}hidden{% endif %}">
      {%- comment -%}theme-check-disable RemoteAsset{%- endcomment -%}
      {%- if icon_url -%}<img class="product-badge-v2__icon" src="{{ icon_url }}" aria-hidden="true" height="24" width="24" /> {%- endif -%}
      {%- comment -%}theme-check-enable RemoteAsset{%- endcomment -%}
      {{ label_text }}
    </span>
    {%- if percentage_saved -%}
      <span class="product-badge-v2__text product-badge-v2__text--percentage-off {% unless settings.product_pricing_show_percentage_saved %}hidden{% endunless %}">{{ percentage_saved }}</span>
    {%- endif -%}
  </div>
{%- endif -%}`;
// Exports
export default code;